// extracted by mini-css-extract-plugin
export default {"wrapper":"CenterLeftBox_wrapper__BVdnM","top":"CenterLeftBox_top__4XgZ6","center":"CenterLeftBox_center__l9VRC","bottom":"CenterLeftBox_bottom__F+GAp"};